import * as Yup from 'yup';

import {
  GENERAL_FORM_EXTENDED_MINIMUM_TEXT_LENGTH,
  GENERAL_FORM_MINIMUM_TEXT_LENGTH,
  GENERAL_FORM_ZIP_CODE_LENGTH,
} from './constants';

export const GENERAL_INFO_FORM_SCHEMA = Yup.object({
  provider_full_name: Yup.string()
    .min(
      GENERAL_FORM_EXTENDED_MINIMUM_TEXT_LENGTH,
      `Name must be at least ${GENERAL_FORM_EXTENDED_MINIMUM_TEXT_LENGTH} characters`,
    )
    .required('Name is required'),
  provider_email: Yup.string().email('Enter a valid email').required('Email address is required'),
  primary_language: Yup.string().required('Primary language is required'),
  relationship_to_client: Yup.string().required('Relationship to child is required'),
  client_first_name: Yup.string()
    .min(
      GENERAL_FORM_MINIMUM_TEXT_LENGTH,
      `Client first name must be at least ${GENERAL_FORM_MINIMUM_TEXT_LENGTH} characters`,
    )
    .required('Client first name is required'),
  client_middle_name: Yup.string(),
  client_last_name: Yup.string()
    .min(
      GENERAL_FORM_MINIMUM_TEXT_LENGTH,
      `Client last name must be at least ${GENERAL_FORM_MINIMUM_TEXT_LENGTH} characters`,
    )
    .required('Client last name is required'),
  client_date_of_birth: Yup.mixed().required('Client date of birth is required'),
  client_sex: Yup.string().required('Client sex is required'),
  client_address_same_as_provider: Yup.boolean(),
  client_street_address_line_one: Yup.string()
    .min(
      GENERAL_FORM_EXTENDED_MINIMUM_TEXT_LENGTH,
      `Street address line one must be at least ${GENERAL_FORM_EXTENDED_MINIMUM_TEXT_LENGTH} characters`,
    )
    .required('Street address line one is required'),
  client_street_address_line_two: Yup.string(),
  client_street_address_zip: Yup.string()
    .length(
      GENERAL_FORM_ZIP_CODE_LENGTH,
      `Zip code must be exactly ${GENERAL_FORM_ZIP_CODE_LENGTH} characters`,
    )
    .required('Zip code is required'),
  client_street_address_city: Yup.string()
    .min(
      GENERAL_FORM_EXTENDED_MINIMUM_TEXT_LENGTH,
      `City must be at least ${GENERAL_FORM_EXTENDED_MINIMUM_TEXT_LENGTH} characters`,
    )
    .required('City is required'),
  client_street_address_state: Yup.string().required('State is required'),
});
